import _get from 'lodash/get';
import { FONT_AWESOME_DEFAULT_PREFIX } from './Icon.constants';
export var iconLibrary = {
  FontAwesome: 'FontAwesome',
  SemanticUI: 'SemanticUI'
};
export var iconNameLibraryMap = {
  tiktok: iconLibrary.FontAwesome,
  'arrow-left': iconLibrary.FontAwesome,
  'arrow-right': iconLibrary.FontAwesome,
  'quote-left': iconLibrary.FontAwesome,
  'quote-right': iconLibrary.FontAwesome,
  phone: iconLibrary.FontAwesome,
  'chevron-left': iconLibrary.FontAwesome,
  'chevron-right': iconLibrary.FontAwesome,
  'chevron-down': iconLibrary.FontAwesome,
  'chevron-up': iconLibrary.FontAwesome,
  'chevron-double-left': iconLibrary.FontAwesome,
  'chevron-double-right': iconLibrary.FontAwesome,
  'chevron-double-down': iconLibrary.FontAwesome,
  'chevron-double-up': iconLibrary.FontAwesome,
  xmark: iconLibrary.FontAwesome
};
export var iconClassMap = {
  tiktok: ['fab', 'tiktok']
};
export function getLibraryFromIconName() {
  var iconName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return _get(iconNameLibraryMap, iconName.toLowerCase(), iconLibrary.SemanticUI);
}
export function getIconClassFromIconName() {
  var iconName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return _get(iconClassMap, iconName.toLowerCase(), [FONT_AWESOME_DEFAULT_PREFIX, iconName.toLowerCase()]);
}